export enum CashbackTypeEnum {
    PROPOSTA = 'proposta',
    CONVITE = 'convite',
    RESGATE = 'resgate',
    PROPOSTA_INDICACAO = 'proposta_indicacao'
}